const zhHant = {
  home: {
    // HoneView.vue
    cancelSubscriptionSuccess: "你已經取消訂閱。",
    cancelSubscriptionFail: "取消訂閱失敗，請重試。",
    // TopBannerComponent.vue
    topBanner: "頂部橫幅",
    // BannerComponent.vue
    slideImg: "幻燈片圖片",
    title1: "P360 Smartcap",
    title2: "抗病毒、抗污染",
    subtitle1: "高效率過濾空氣 + 負離子氣流",
    subtitle2: "為你淨化空氣 時刻保護你的健康",
    knowMore: "了解更多",
    // award section
    awardTitle: "獎項",
    award1: "最具創意獎 - 知識產權之創科大本營",
    award2: "零售科技創新大獎 2022",
    award3: "銀獎 - 亞洲國際創新發明大獎",

    // IntroComponent.vue
    intro:
      "SmartCap作為新一代的便攜式空氣淨化裝置，內置的負離子產生器和HEPA濾棉提供雙重防護，有效過濾和吸附懸浮粒子、病毒和花粉，並且在面部前方形成由上而下的單向氣流，最大程度上阻隔病毒和污染物的侵襲。即使外出，也能呼吸新鮮乾淨的空氣，有效保障你的健康。",
    buyNow: "立即購買",
    youtubeTitle: "YouTube影片播放器",
    detailsTitle: "購買SmartCap的理由",
    details1:
      "高效防護：SmartCap內置負離子產生器和HEPA濾棉。負離子能夠吸附空氣的固態懸浮粒子，使其墜落地面，而且能夠分解甲醛、甲苯等等部份氣態污染物，而HEPA濾棉 (high efficiency particulate air filter)能夠過濾空氣高達99.7%的灰塵、花粉和病毒。負離子和經過HEPA濾棉過濾的空氣通過高速風機，由帽簷下方吹向面部，在面部前方形成氣流防護罩，阻隔外來的混濁空氣，使用戶不論在室內或室外，都能呼吸清新空氣。",
    details2:
      "隱藏式設計：所有空氣淨化組件都力求壓縮到最小體積，而且均隱藏於帽子內部。SmartCap的外形和配戴方式與一般鴨舌帽無異。外出時，毋須擔心引人注目。配戴時亦有舒適體驗。.",
    details3:
      "方便使用：隱藏式開關位於帽子側面的P360 TEC標誌後面。只要輕輕一按，就能開啟空氣淨化功能。",
    details4: "持久續航：電池續航時間長達5小時，為你提供長時間保護。",
    details5: "",
    smartCap: "P360 SmartCap ✔",
    otherProducts: "一般空氣淨化項鍊",
    wearPosition: "防護功率",
    wearPositionSmartCap:
      "空氣淨化裝置位於額頭前方，經過濾的潔淨空氣直接吹送到面部",
    wearPositionOther: "掛在胸前，淨化的空氣四處飄散",
    hidden: "隱蔽性",
    hiddenSmartCap:
      "空氣淨化組件隱藏於帽子中，外形與一般鴨舌帽無異，不會引人注目",
    hiddenOther: "旁人輕易看見",
    filteringMedium: "過濾裝置",
    filteringMediumSmartCap: "負離子及濾棉雙重防護",
    filteringMediumOther: "單一負離子防護",
    productPrice: "價錢",
    productPriceSmartCap: "HKD$780 (早鳥優惠)",
    productPriceOther: "上千元",
    // CancelSubscriptionComponent.vue
    cancelSubscriptionTitle1: "你確定取消訂閱",
    cancelSubscriptionTitle2: "我們的資訊嗎?",
    cancelSubscriptionConfirm: "確認",
  },
  aboutUs: {
    title: "P360 Technology",
    subtitle: "360°全面防護",
    intro1Title: "P360 公司",
    intro1:
      "P360 TEC是一間於2019年成立的創新科技公司。我們憑藉科技與智慧的結合，為大眾提供可靠的空氣淨化產品，希望大眾不論何時何地都能呼吸新鮮空氣。SmartCap，就是本公司的產品之一，能夠在面部前方形成防護罩，使用戶可以在任何時候都能享受清新空氣，並且保護你的健康。",
    intro2Title: "P360 團隊",
    intro2:
      "我們擁有強大的團隊，團隊成員各司其職，力求在產品設計和工程方面做到最好。我們深感現時世界危機重重，正在破壞人類整體的健康，由汽車廢氣、工業污染，再到Covid-19，人們急需能夠保護呼吸系統的新型產品。正因如此，我們發起了便攜式空氣淨化裝置的項目，並且命名為SmartCap，希望我們的產品能夠真正保護你的健康。",
    intro3Title: "P360 願景",
    intro3:
      "P360是本公司的名稱，也是本公司的願景。P360，即是360度全面保護 (protect you in 360 degrees) 的意思。在這個時代，疫症流行，空氣污染嚴重。各類問題隨現代化發展而出現。雖然人類已經致力解決這些問題，但是離解決之日遙遙無期。我們希望能夠為大眾創造一個安全和受保護的空間，保障用戶的健康免受侵害。",
  },
  product: {
    // GoToShoppingCartComponent.vue
    goToShoppingCartConfirm: "前往購物車",
    // PaymentConirmComponent.vue
    purchaseConfirm: "確認",
    // ProductComponent.vue
    carouselAlt: "幻燈片圖片",
    carouselPrevious: "上一張",
    carouselNext: "下一張",
    currencyCode: "",
    share: " 分享",
    colour: "顏色：",
    outOfStock: "已售罄",
    quantity: "產品數量",
    pieces: "件",
    purchase: "立即購買",
    addToShoppingCart: "加入購物車",
    details: "特色",
    specs: "規格",
    manual: "支援",
    manualImgText: "用戶指南",
    manualDownload: "按此下載",
    interest: "你可能感興趣的產品",
    outOfStockMsg:
      "此產品處於預售階段，請點擊<a href='/'>這裡</a>了解更多詳情!",
    // ProductInfoComponent.vue
    unitPrice: "單價：",
    totalPrice: "總價：",
    quantity2: "數量：",
    // ShareComponent.vue
    clipboardHint: "點擊複製鏈結",
    ogDescription: "立即購買!",
    copiedHint: "複製成功",
    whatsappAlt: "分享這件產品到 Whatsapp",
    facebookAlt: "分享這件產品到 Facebook",
    twitterAlt: "分享這件產品到 Twitter",
  },
  shoppingCart: {
    // ShoppingCartView.vue
    voucherCodeShortText: "優惠碼",
    voucherCodeLongText: "輸入優惠碼",
    title: "購物車",
    currencyCode: "@:product.currencyCode",
    pieces: "@:product.pieces",
    noProduct: "沒有產品在購物車中。",
    subTotal: "總計",
    voucherCode: "優惠碼",
    checkOut: "結帳",
  },
  trackNTrace: {
    // CheckOrderView.vue
    formTitle: "訂單追蹤",
    formText: "請輸你的電郵和訂單編號",
    email: "電郵：",
    emailPlaceholder: "你結帳時使用的電郵",
    invalidEmail: "無效電郵",
    orderNumber: "訂單編號：",
    orderNumberPlaceholder: "訂單編號",
    invalidOrderNumber: "無效訂單編號",
    formConfirm: "確認",
    // OrderStatusView.vue
    productPhoto: "產品圖片",
    orderId: "訂單 ID",
    datePaid: "付款日期",
    shippingAddress: "運送至",
    shippingStatusOrdered: "已下單",
    shippingStatusShipped: "已發貨",
    shippingStatusOutOfDelivery: "運送中",
    shippingStatusArrived: "已到達",
  },
  footer: {
    // FooterComponent.vue
    subscriptionSuccess: "你已經成功訂閱我們的資訊!",
    subscriptionFailed: "訂閱失敗，請重試。",
    emailSend: "發送",
    emailLoading: "發送中...",
    validEmail: "成功!",
    invalidEmail: "無效電郵或訊息。",
    subscriptionTitle: "訂閱 P360 電子報",
    subscriptionText: "直接從 P360 電子報接收獨家優惠和新產品。",
    subscriptionRegister: "以電郵訂閱",
    subscriptionGoogle: "以 Google 帳號訂閱",
    socialMediaTitle: "關注我們 | 社交媒體",
    socialMediaFacebook: "Facebook 專頁",
    socialMediaInstagram: "Instagram 專頁",
    socialMediaYoutube: "Youtube 頻道",
    contactUs: "聯絡我們",
    emailAddressPlaceholder: "輸入你的電郵...",
    emailContentPlaceholder: "留下你的訊息...",
    phoneNumber: "聯絡電話：",
    emailAddress: "聯絡電郵：",
    address: "地址：",
    patentNumber: "專利編號：",
    copyright1: "版權所有",
    copyright2: "，不得轉載。",
    sponsored: "合作伙伴",
    "Sponsored#1": "香港科學園企業自研護膚品牌純肌",
    "Sponsored#2": "香港科學園企業自研電動車充電平台",
    "Sponsored#3": "香港科學園企業自研智能防護帽",
    "Sponsored#4": "香港企業自研網約車平台",
  },
  header: {
    // HeaderComponent.vue
    buyNow: "立即購買",
    aboutUsLong: "關於我們",
    shoppingCart: "購物車",
    orderTracking: "訂單追蹤",
    aboutUsShort: "關於我們",
  },
  shippingAddressForm: {
    // ShippingAddressComponent.vue
    title1: "貨運地址",
    name: "名字：",
    email: "電郵：",
    line1: "詳細地址（第一行）：",
    line2: "詳細地址（第二行）：",
    city: "城市：",
    state: "州／省：",
    country: "國家：",
    postalCode: "郵政編碼：",
    hint1: "* 必填",
    hint2: '^ 如果你不清楚郵政編號或所在地區沒有郵政編號，填寫 "000000"',
    nextStep: "下一步",
    title2: "運送至",
    currencyCode: "@:product.currencyCode",
    previousStep: "上一步",
    submitLoading: "確認中...",
    submitNormal: "確認",
    require: "（必填）",
    emailNotValid: "（電郵格式無效）",
    serverError: "（伺服器錯誤，請重試。）",
  },
  payment: {
    // StripeComponent.vue
    unexpectedError: "出現未知錯誤。",
    paymentStatusSucceeded: "付款成功!",
    paymentStatusProcessing: "你的付款正在處理中",
    paymentStatusRequires: "付款失敗，請重試。",
    paymentStatusError: "出現錯誤!",
    currencyCode: "@:product.currencyCode",
    totalPrice: "總價：",
    stripeLoading: "請等等...",
    stripePayNow: "立即付款",
    // PaymentFinishedComponent.vue
    paymentFinishedTitle: "感謝你購買我們的產品!",
    paymentFinishedId: "你的訂單編號是",
    paymentFinishedReceipt: "收據稍後就會寄送至 {receiptEmail}",
    goShopping: "前往購物",
    saveAsImg: "以圖片格式保存資訊",
    tnt: "追蹤你的訂單",
    paymentNotFinished: "請重試。",
  },
  subscription: {
    // SubscriptionComponent.vue
    formTitle: "訂閱電子報",
    formName: "你的名字：",
    formEmail: "你的電郵：",
    formSubmit: "確認",
  },
};

const zhHantNumberFormats = {
  currency: {
    style: "currency",
    currency: "HKD",
    currencyDisplay: "symbol",
    useGrouping: true,
  },
};

export { zhHant, zhHantNumberFormats };
